import { createSlice } from "@reduxjs/toolkit";


const nameSlice = createSlice({
    name:'Global',
    initialState:{
        state:0
    },
    reducers:{
        changeState(state,{payload}){
            console.log('jinlai le',payload)
            state.state = payload
        }
    }
})
export const getters = (state)=>{
    console.log('++++++++++++',state)
    return state.Global
}
export const {changeState} = nameSlice.actions
export default nameSlice.reducer
